import { Helmet } from 'react-helmet-async'

const SITE_URL = 'https://dristantasilwal.com.np'
const DEFAULT_IMAGE = `${SITE_URL}/og-default.png`

export default function Seo({
    title,
    description,
    canonicalPath = '/',
    noindex = false,
    image = DEFAULT_IMAGE,
    type = 'website',
    jsonLd = null,
}) {
    const canonicalUrl = `${SITE_URL}${canonicalPath}`
    const jsonLdList = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : []

    return (
        <Helmet>
            <title>{title}</title>
            {description && <meta name="description" content={description} />}
            <link rel="canonical" href={canonicalUrl} />
            {noindex && <meta name="robots" content="noindex,nofollow" />}

            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={image} />

            {jsonLdList.map((schema, i) => (
                <script key={i} type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            ))}
        </Helmet>
    )
}
